import toastMessage from "../toastMessage";
import { getStorage } from "../storage";
import api from "../api";
import language from "../../language";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

export const fetchReturnRequest = async (
  lng = "english",
  { page, limit, id, q, returnNumber }
) => {
  try {
    const user = await getStorage();

    const options = {
      method: "GET",
      url: `${API_URL}/return-request`,
      params: {
        page,
        limit,
        id,
        q,
        stock: user.stock,
        returnNumber,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    const queryRes = await api(options);

    let { data, count, totalRecords } = queryRes.data;

    return !page && !limit ? queryRes.data : { data, count, totalRecords };
  } catch (error) {
    toastMessage("error", error);
  }
};

export const deleteReturnRequest = async (lng, id) => {
  try {
    const user = await getStorage();

    const options = {
      method: "DELETE",
      url: `${API_URL}/return-request`,
      data: {
        id,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    await api(options);

    toastMessage("success", language[lng].delete_data_success);
  } catch (error) {
    toastMessage("error", error);
  }
};
